import { Component, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { selectAllTasksViews } from '@tv3/store/task/task.selectors'
import * as R from 'ramda'
import { Task } from '@tv3/store/task/task.model'
import { Destroyable, isSomething, LocalStorage, untilDestroy } from '@tokeet/tv3-platform'
import { SkipMasterLayoutService } from '@tv3/services/utils/skip-master-layout.service'
import { InfoDialogService } from '@tokeet/tv3-platform'
import { AuthService } from '@tv3/services/auth.service'
import { NgProgress } from '@ngx-progressbar/core'
import { environment } from '@tv3/environments/environment'
import { map } from 'rxjs/operators'
import { KEY_TOKEN } from '@tokeet-frontend/auth'
import { buildAdvanceRedirectUrl } from '@tv3/utils/advance-redirect'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent extends Destroyable implements OnInit {
  past: number
  pending: number
  completed: number
  all: number

  get isOwner() {
    return this.authService.hasRole('owner')
  }

  isLoading$ = this.progress.ref().state.pipe(map((state) => state.active))
  constructor(
    private skipMasterLayout: SkipMasterLayoutService,
    private infoService: InfoDialogService,
    private authService: AuthService,
    private storage: LocalStorage,
    private store: Store<fromRoot.State>,
    private progress: NgProgress
  ) {
    super()
  }

  ngOnInit() {
    this.store.pipe(select(selectAllTasksViews), untilDestroy(this)).subscribe((tasks) => {
      this.past = R.filter((t: Task) => t.past && t.status !== 2, tasks).length
      this.pending = R.filter((t: Task) => t.pending && t.status !== 2, tasks).length
      this.completed = R.filter((t: Task) => t.status === 2, tasks).length
      this.all = tasks.length
    })
  }

  get isVisible(): boolean {
    return !this.skipMasterLayout.check()
  }

  reportsUrl() {
    let token = this.authService.token
    if (!isSomething(token)) {
      token = this.storage.get(KEY_TOKEN)
    }
    return `${environment.reportsUrl}login?token=${token}`
  }

  acmFeatureUrl(redirectPath: string) {
    let token = this.authService.token
    if (!isSomething(token)) {
      token = this.storage.get(KEY_TOKEN)
    }
    return buildAdvanceRedirectUrl({
      token,
      redirectPath,
      advanceBaseUrl: environment.acmAppUrl,
      tv3BaseUrl: window.location.origin,
    })
  }
}
